export default __webpack_public_path__ + "static/media/jobsapp.9a53452e.mp4";